import { HTTP as Cerbos } from '@cerbos/http';
import { CERBOS_API_URL } from '@skynet/config-provider';

export const CerbosClient = new Cerbos(CERBOS_API_URL);
